$(function () {
    $('[data-toggle="tooltip"]').tooltip()
    $('[data-toggle="popover"]').popover().css('cursor', 'pointer');
})

toastr.options = {
    "closeButton": false,
    "debug": false,
    "newestOnTop": false,
    "progressBar": false,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
}

function setContentHeight() {
    let h = parseFloat(window.innerHeight - (55 + 41));
    $('#main')
        .css('max-height', h)
        .css('height', h)
        .css('margin-top', '55px')
        .css('margin-bottom', '41px');
    $('#side-panel')
        .css('max-height', h)
        .css('height', h)
        // .css('margin-top', '55px')
        .css('margin-bottom', '41px');
    $('#main-content')
        .css('max-height', h)
        .css('height', h)
        // .css('margin-top', '55px')
        .css('margin-bottom', '41px');
}
setContentHeight();
$(window).on('resize', function() {
    setContentHeight();
    // resizeMainPanel();
})
